import React from "react";
import PropTypes from "prop-types";
import styles from "./CommonInputFile.module.css";

/**
 * Input reutilizável para arquivos
 */
function CommonInputFile({
  label,
  id,
  onChange,
  accept,
  required = false,
  disabled = false,
  ...props
}) {
  const [fileName, setFileName] = React.useState("Nenhum arquivo selecionado");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
    } else {
      setFileName("Nenhum arquivo selecionado");
    }

    if (onChange) {
      onChange(e);
    }
  };

  return (
    <>
      {label && (
        <>
          <label htmlFor={id} className={styles.label}>
            {label}
          </label>
          {required && <span style={{ color: "#f46a6a" }}> *</span>}
        </>
      )}
      <div
        className={`${styles["file-input-wrapper"]} ${disabled ? styles["disabled"] : ""}`}
        onClick={() => {
          document.getElementById(id).click();
        }}
      >
        <label htmlFor="file" className={styles["custom-file-label"]}>
          Escolher arquivo
        </label>
        <input
          type="file"
          id={id}
          disabled={disabled}
          onChange={disabled ? null : handleFileChange}
          className={styles["custom-file-input"]}
          accept={accept}
          name={id}
          {...props}
        />
        <span className={styles["file-name"]}>{fileName}</span>
      </div>
    </>
  );
}

CommonInputFile.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  accept: PropTypes.string.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default CommonInputFile;
